<template>
  <div class="wrapper">
    <public-title phone="手机号" name="昵称" sex="性别" viptype="会员类型" @gotoinquire="eventinquire" :vip="vipdata"></public-title>
    <!-- <div class="content">
      <el-table
        :data="tabledata"
        style="width: 100%;" @sort-change="sortChange" >
        <el-table-column
          prop="nickname"
          label="昵称"
          width="180"
          align="center"
          sortable="custom"
          >
        </el-table-column>
        <el-table-column
          prop="phone"
          label="手机号"
          width="120"
          align="center"
          sortable="custom"
          >
        </el-table-column>
        <el-table-column
          prop="membershipType"
          label="会员类型"
          width="120"
          align="center"
          sortable="custom"
          >
        <template slot-scope="scope">
          <span v-if="scope.row.membershipType === 1">试用会员</span>
          <span v-else>正式会员</span>
        </template>
        </el-table-column>
        <el-table-column
          prop="sex"
          label="性别"
          width="80"
          align="center"
          sortable="custom"
          >
        <template slot-scope="scope">
          <span v-if="scope.row.sex==1">男</span>
          <span v-else-if="scope.row.sex==2">女</span>
        </template>
        </el-table-column>
        <el-table-column
          prop="age"
          label="年龄"
          align="center"
          sortable="custom"
          >
        </el-table-column>
        <el-table-column
          prop="birthday"
          width="120"
          label="生日"
          align="center"
          sortable="custom"
          >
        <template slot-scope="scope">
          {{scope.row.birthday.split(' ')[0]}}
        </template>
        </el-table-column>
        <el-table-column
          prop="province"
          label="省"
          align="center">
        </el-table-column>
        <el-table-column
          prop="city"
          label="市"
          align="center">
        </el-table-column>
        <el-table-column
          prop="area"
          label="区"
          align="center">
        </el-table-column>
        <el-table-column
          prop="ip"
          label="ip"
          align="center">
        </el-table-column>
        <el-table-column
          prop="email"
          label="邮箱"
          width="200"
          align="center">
        </el-table-column>
        <el-table-column
          label="头像"
          width="180"
          align="center">
        <template slot-scope="scope">
          <img  style="border-radius: 50%;width: 50px;height: 50px;" :src="URL + scope.row.imgPath" alt="">
        </template>
        </el-table-column>
        <el-table-column label="操作" width="250" align="center" fixed="right">
          <template slot-scope="scope">
              <el-button slot="reference" size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      
      
    </div> -->
    <common-table
      :table-options="tableOptions"
      :table-data="tabledata"
      :is-loading="isLoading"
      handleSelectionChange="handleSelectionChange"
      @sortChange="sortChange"
      :show-selection="false"
    >
      <template #default="{scope}">
        <el-button
          @click="handleDelete(scope.$index, scope.row)"
          type="danger"
          icon="el-icon-delete"
          size="mini"
          >删除</el-button
        >
      </template>
     
    
    </common-table>
    <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[15, 30, 40, 50]"
        :page-size="100"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totals">
    </el-pagination>
  </div>
  
</template>
<script>
import publicTitle from '../../../components/publicTitle'
export default {
  components: {publicTitle},
  props: {},
  data() {
    return {
      tabledata: [],
      isLoading: false,//加载动画效果
      tableOptions: [
        { label: "昵称", prop: "nickname" ,sortable:"custom", width: "150"},
        { label: "手机号", prop: "phone" , sortable:"custom",width: "150"},
        { label: "会员类型", prop: "membershipType", sortable:"custom",width: "150",
          formatter: function(row) {
            if (row.membershipType == 1) {
              return <el-tag type="info">试用会员</el-tag>;
            } else if (row.membershipType == 2) {
              return <el-tag>正式会员</el-tag>;
            }
          }
         },
        { label: "性别", prop: "sex" , sortable:"custom", width: "150",
          formatter: function(row) {
            if (row.sex == 1) {
              return <el-tag>男</el-tag>;
            } else if (row.sex == 2) {
              return <el-tag>女</el-tag>;
            }
          }
        },
        { label: "年龄",prop: "age", sortable:"custom", width: "150"},
        { label: "生日", prop: "birthday" ,sortable:"custom", width: "150"},
      { label: "省", prop: "province" , width: "150"},
      { label: "市", prop: "city" , width: "150"},
      { label: "区", prop: "area" , width: "150"},
      { label: "ip", prop: "ip" , width: "150"},
      { label: "邮箱", prop: "email" , width: "150"},
      { label: "头像", prop: "imgPath" , width: "70",
       formatter: function(row) {
            return (
              <el-image
                src={row.imgPath}
                class="table-img"
                fit="contain"
              >
              </el-image>
            );
          }
      },
      ],
      vipdata:[],
      currentPage: 1,
      pageSize:15,
      pageIndex:1,
      totals:0,
      form:{},
      URL:'' , //图片URL
      sortName:"",//排序名称
      sortType:"",//排序升序降序
    };
  },
  computed: {

  },
  mounted() {
    console.log("进来页面")
    this.updata()
    this.detailslist()
      this.URL = this.$URL
  },
  methods: {
    updata (pageIndex=1,pageSize=15,Vphone='',Vname='',Vsex='',Vviptype='') {
      this.isLoading = true;
      if(this.sortType == null){
          this.sortType = "";
          this.sortName = "";
        }
        let sortType = this.sortType;
        let sortName =this.sortName;
      this.$http({
        // &phone=${phone}
        url: this.$api.viplist+`?pageIndex=${pageIndex}&pageSize=${pageSize}&phone=${Vphone}&nickname=${Vname}&sex=${Vsex}&membershipType=${Vviptype}&sortName=${sortName}&sortType=${sortType}`,
        method: "GET",
      }).then(res => {
        if (res.data.code == 200) {
          // console.log(res.data, "返回");
          this.tabledata = res.data.data.records;
          console.log("数据",this.tabledata)
          this.pageSize = res.data.data.size;
          this.currentPage = res.data.data.current;
          this.totals = res.data.data.total;
          let arr =[];
          let list = this.tabledata;
          for(let i=0;i<list.length;i++){
                list[i].imgPath = this.URL+list[i].imgPath;
          }
          // console.log("list",list)
          this.isLoading = false;
        }else{
            this.$toast("error", res.data.msg);
          }
      });
    },
    detailslist(){
      this.$http({
        url: this.$api.detailslist + `?type=membershipType`,
        method: "GET",
      }).then(res => {
        if (res.data.code == 200) {
          this.vipdata = res.data.data
          this.vipdata.unshift({
          value: ' ',
          name: '全部'
        })
        }
      })
    },
    eventinquire (form){
      this.form = form
      this.updata(1,this.pageSize,this.form.Vphone,this.form.Vname,this.form.Vsex,this.form.Vviptype)
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.updata(this.pageIndex,this.pageSize,this.form.Vphone,this.form.Vname,this.form.Vsex,this.form.Vviptype)
    },
    handleCurrentChange(val) {
      this.pageIndex = val
      this.updata(this.pageIndex,this.pageSize,this.form.Vphone,this.form.Vname,this.form.Vsex,this.form.Vviptype)
    },
    sortChange (column, event) {
         console.log("column")
        this.sortName = column.prop;
        this.sortType = column.order;
        // if(column.order =='ascending'){
        //   this.sortType = 'asc'
        //   }else if(column.order =='descending'){
        //     this.sortType = 'desc'
        //     }else{
        //       this.sortType = ''
        //       };
        this.updata(this.pageIndex,this.pageSize,this.form.Vphone,this.form.Vname,this.form.Vsex,this.form.Vviptype)
      
    },
    //删除 
      handleDelete(index, item) {
         this.$confirm("您确定要删除这一条记录吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        console.log("item",item)
        this.$http({
          url: this.$api.memberdel + `${item.userId}`,
          method: "DELETE",
        }).then(res => {
          if (res.data.code == 200) {
            this.$toast("success", res.data.msg);
            this.updata(1, this.pageSize,this.form.Vphone,this.form.Vname,this.form.Vsex,this.form.Vviptype)
          }else{
            this.$toast("error", res.data.msg);
          }
          this.DelVisible = false
        });
      })
        
      },
  },
  created() {},
  beforeDestroy() {}
};
</script>

<style lang="scss" scoped>
.role-select{
  width: 290px !important;
}
// .content{
//   background: #fff;
//   width: 100%;
//   height: 100%;
// }
/deep/.el-pagination{
  text-align: center;
  padding-bottom: 10px;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
}
/deep/.el-table{

      height: 100%;
      overflow-x: scroll;//table横向滚动
}
// .el-table{  
//       width:100%;
//       height: 100%;
//       overflow: auto;
// }
  .wrapper{
    width: 100%;
    height: 100%;
    // overflow: scroll;
    // overflow-y:scroll;
  //      ::-webkit-scrollbar {
  //    height: 0 !important;
  //  }
  //  ::-webkit-scrollbar {
  //    height: 0 !important;height: 0;
  //  }

  }
  /deep/.el-table::before{
  background-color: none;
  opacity:0;
}
// /deep/.el-table__body-wrapper{
//     height:62vh;
//     overflow: auto;
// }
/deep/.el-table th>.cell{
  color: #000;
}


// /deep/.el-table__fixed-right{
//       width: 100px;
//       //  height: 420px!important;
//         right: 20px;
//         /deep/.el-table__fixed-body-wrapper{
//         // top: 69px!important; //右边操作栏距离顶部的高度
       
//       }
//       }
// .el-table--scrollable-y .el-table__body-wrapper {
//   height: 671px;
// overflow-y: auto;
// }
</style>
